'use client';

import { motion } from 'framer-motion';
import { HeroDualShowcase } from '@/components/HeroDualShowcase';
import { Link } from '@/i18n/navigation';
import { ScanLine } from 'lucide-react';

export const Hero = () => {
	return (
		<div className="pt-8 sm:pt-16 pb-4 text-center relative overflow-hidden">
			{/* Main Hero Headline */}
			<motion.h1
				initial={{ opacity: 0, y: 15 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5 }}
				className="mx-auto max-w-4xl text-4xl sm:text-5xl lg:text-[64px] font-black tracking-tight text-slate-900 leading-[1.1] mb-4 sm:mb-6 px-4"
			>
				Dynamic QR Codes &amp; Smart Digital Experiences
			</motion.h1>

			{/* Subtitle */}
			<motion.p
				initial={{ opacity: 0, y: 15 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5, delay: 0.1 }}
				className="mx-auto max-w-2xl text-base sm:text-xl text-slate-600 leading-relaxed font-medium mb-8 px-4"
			>
				Create, customize, and track high-converting QR codes, digital business cards, and mobile
				menus. <strong className="font-bold text-slate-900">100% Free. No credit card required.</strong>
			</motion.p>

			{/* Primary Action Buttons */}
			<motion.div
				initial={{ opacity: 0, y: 15 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5, delay: 0.15 }}
				className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12 sm:mb-16 px-4 max-w-md mx-auto sm:max-w-none"
			>
				<Link
					href="/create"
					className="w-full sm:w-auto inline-flex items-center justify-center bg-slate-900 hover:bg-slate-800 text-white font-bold text-base px-8 py-4 rounded-xl shadow-md transition-colors"
				>
					Create Free QR Code
				</Link>
				<Link
					href="/scanner"
					className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 text-slate-700 font-bold text-base px-8 py-4 rounded-xl border-2 border-slate-200 transition-colors"
				>
					<ScanLine className="size-5" />
					<span>Scan Barcode / QR</span>
				</Link>
			</motion.div>

			{/* Dual-Card Centerpiece */}
			<motion.div
				initial={{ opacity: 0, y: 20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.6, delay: 0.2 }}
			>
				<HeroDualShowcase />
			</motion.div>
		</div>
	);
};
